<template>
  <aside
    class="sidebar"
  >
    <div class="sidebar-content">
      <div class="sidebar-header">
        <img
          src="@/assets/logo.png"
          alt="App Logo"
          class="sidebar-logo"
        >
      </div>
      <nav class="menu">
        <p class="menu-label">
          Menu
        </p>
        <ul class="menu-list">
          <li>
            <a
              href="#"
              class="is-active"
            >
              <i class="fas fa-view-dashboard" />
              <span>Dashboard</span>
            </a>
          </li>
        </ul>
        <p class="menu-label">
          Settings
        </p>
        <ul class="menu-list">
          <li>
            <a
              href="#"
              @click.prevent="goToChangePassword"
            >
              <i class="fas fa-cog" />
              <span>Change Password</span>
            </a>
          </li>
        </ul>
        <p class="menu-label">
          Actions
        </p>
        <ul class="menu-list">
          <li>
            <a
              href="#"
              @click.prevent="logout"
            >
              <i class="fas fa-sign-out-alt" />
              <span>Logout</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'AdminSidebar',
  props: {
  },
  methods: {
    logout() {
      localStorage.removeItem('admin-token');
      this.$router.push('/admin/login');
    },
    goToChangePassword() {
      this.$emit('open-change-password-modal');
    }
  }
};
</script>

<style scoped>
.sidebar {
  width: 250px;
  background: transparent;
  color: #fff;
  transition: transform 0.3s ease;
}

.sidebar.is-open {
  transform: translateX(0);
}

.sidebar-content {
  padding: 20px;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.sidebar-logo {
  max-width: 220px;
}

.sidebar-toggle-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
}

.menu-label {
  font-size: 0.9rem;
  text-transform: uppercase;
  color: #a0aec0;
  margin-top: 20px;
  margin-bottom: 10px;
  letter-spacing: 0.5px;
}

.menu-list li a {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-radius: 8px;
  color: #e2e8f0;
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.menu-list li a:hover,
.menu-list li a.is-active {
  background-color: #3b82f6;
  color: white;
}

.menu-list li a i {
  margin-right: 10px;
  font-size: 1.1rem;
}
</style>
